import React, { useState } from "react";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة التسارع - كيفية حساب التسارع";
const DESCRIPTION =
  "حاسبة التسارع تقوم بحساب التسارع بناءً على التغير في السرعة والزمن.";
const KEYWORDS =
  "حساب التسارع, حاسبة التسارع, حساب التسارع بناءً على التغير في السرعة والزمن";
const OG_URL = "https://do-calculate.com/calculator/ar/acceleration";
function AccelerationCalculator() {
  const [initialVelocity, setInitialVelocity] = useState("");
  const [finalVelocity, setFinalVelocity] = useState("");
  const [time, setTime] = useState("");
  const [acceleration, setAcceleration] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!initialVelocity || !finalVelocity || !time) {
      setError(
        "الرجاء إدخال السرعة الابتدائية والسرعة النهائية والزمن بشكل صحيح"
      );
      setAcceleration("");
      return;
    }
    const initialVelocityValue = parseFloat(initialVelocity);
    const finalVelocityValue = parseFloat(finalVelocity);
    const timeValue = parseFloat(time);
    if (
      isNaN(initialVelocityValue) ||
      isNaN(finalVelocityValue) ||
      isNaN(timeValue)
    ) {
      setError(
        "الرجاء إدخال قيم صحيحة للسرعة الابتدائية والسرعة النهائية والزمن"
      );
      setAcceleration("");
      return;
    }
    const deltaVelocity = finalVelocityValue - initialVelocityValue;
    const deltaT = timeValue;
    const accelerationValue = deltaVelocity / deltaT;
    setAcceleration(accelerationValue.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  أهلًا بكِ! يمكن التعبير عن التسارع رياضيًا بقانونين رئيسيين
                  حسب المعطيات في السؤال. في هذه الحالة، نستخدم القانون التالي:
                </p>
                <p>التسارع = التغير في السرعة / التغير في الزمن</p>
                <p>ت = ∆ع / ∆ز</p>
                <p>حيث:</p>
                <ul>
                  <li>ت: التسارع، ويُقاس بوحدة م/ث².</li>
                  <li>
                    ∆ع: التغير في السرعة (السرعة النهائية - السرعة الابتدائية)
                    وتُقاس بوحدة م/ث.
                  </li>
                  <li>
                    ∆ز: التغير في الزمن (الزمن النهائي - الزمن الابتدائي) وتُقاس
                    بوحدة ث.
                  </li>
                </ul>
                <p>
                  لحساب التسارع، قم بإدخال القيم اللازمة وانقر على "احسب
                  التسارع" للحصول على النتيجة.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          السرعة الابتدائية (م/ث)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="0"
                        value={initialVelocity}
                        onChange={(e) => setInitialVelocity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          السرعة النهائية (م/ث)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="60"
                        value={finalVelocity}
                        onChange={(e) => setFinalVelocity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الزمن (ثانية)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="4"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب التسارع
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {acceleration !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              التسارع (م/ث²): {acceleration}
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              خطوات الحل: <br />- كتابة القانون: التسارع =
                              التغير في السرعة / التغير في الزمن - تعويض
                              المعطيات وحساب الناتج.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default AccelerationCalculator;
